<template>
  <NuxtLayout>
    <div class="wrapper">
      <div class="flex flex-col items-center space-y-5">
        <h1
          class="text-center text-primary font-extrabold"
        >
          404
        </h1>
        <h3 class="text-center text-3xl">
          {{ $t("not_found.page.title") }}
        </h3>
        <div class="min-w-40px">
          <RouterLink class="w-full text-primary-blue underline" to="/">
            {{ $t("not_found.page.label") }}
          </RouterLink>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<style scoped>
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}
h1 {
  font-weight: 900;
  font-size: 100px;
  text-align: center;
}
</style>
